<svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.077 20.274L16.1039 2.22025L17.1126 2.72575L8.08576 20.7795L7.077 20.274Z" fill="#E0E0E0"/>
</svg>
